import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 7V5c0-1.1.9-2 2-2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 3h2c1.1 0 2 .9 2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 17v2c0 1.1-.9 2-2 2h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "5", x: "7", y: "7", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "7", height: "5", x: "10", y: "12", rx: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Group";
const Group = memo(themed(Icon));
export {
  Group
};
//# sourceMappingURL=group.js.map
